"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutateUserOptionSet = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const USER_OPTION_SET_MUTATION = (0, graphql_tag_1.default) `
  mutation UserOptionSet($key: String!, $value: String!) {
    userOptionSet(key: $key, value: $value) {
      value
      key
    }
  }
`;
const mutateUserOptionSet = async (variables) => {
    const { data, errors } = await (0, apollo_1.mutate)(USER_OPTION_SET_MUTATION, {
        variables,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.userOptionSet;
};
exports.mutateUserOptionSet = mutateUserOptionSet;
